import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import {
  Box,
  Flex,
  HStack,
  Text,
  useColorModeValue,
  Collapse,
} from '@chakra-ui/react';
import { ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons';

import routes from '../../../routes';

function SidebarLinks() {
  const location = useLocation();
  const activeColor = useColorModeValue('gray.700', 'white');
  const inactiveColor = useColorModeValue(
    'secondaryGray.600',
    'secondaryGray.600',
  );
  const textColor = useColorModeValue('secondaryGray.500', 'white');

  const [openDropdowns, setOpenDropdowns] = useState({});

  const isActive = (path) => location.pathname === path;

  const handleDropdownToggle = (path) => {
    setOpenDropdowns((prev) => ({
      ...prev,
      [path]: !prev[path],
    }));
  };

  const filterRoutes = (routes) => {
    return routes.filter((route) => route.name !== 'Clinical' && route.name !== 'Account Info' && route.name !== 'Generate Bill' && route.name !== 'View Lead' && route.name !== 'Voucher' && route.name !== 'Patient Image' && route.name !== 'Call Log' && route.name !== 'Referral Page');
  };
  
  const renderLinks = (routes) => {
    return filterRoutes(routes).map((route, index) => {
      const routePath = route.path || '';
      const fullPath = `${route.layout || ''}${routePath}`;
      const isRouteActive = isActive(fullPath);
      const isDropdownOpen = openDropdowns[routePath] || false;

      return (
        <Box key={index}>
          <NavLink
            to={route.children ? '#' : `${route.layout || ''}${routePath}`}
            onClick={() => route.children ? handleDropdownToggle(routePath) : null}
            style={{ textDecoration: 'none' }}
          >
            <HStack
              spacing={isRouteActive ? '22px' : '26px'}
              py="5px"
              ps="10px"
              align="center"
              cursor="pointer"
            >
              <Flex w="100%" alignItems="center" justifyContent="space-between">
                <Flex align="center">
                  <Box
                    className={isRouteActive ? 'text-theme-dark text-[18px]' : 'text-[#8F9BBA] text-[18px]'}
                    me='18px'
                  >
                    {route.icon}
                  </Box>
                  <Text
                    me="auto"
                    color={isRouteActive ? activeColor : textColor}
                    fontWeight={isRouteActive ? "bold" : "normal"}
                    className='text-base'
                  >
                    {route.name}
                  </Text>
                </Flex>

                {/* Show dropdown arrow if the route has children */}
                {route.children && (
                  <Box>
                    {isDropdownOpen ? (
                      <ChevronUpIcon boxSize={5} className='!text-[#8F9BBA]'/>
                    ) : (
                      <ChevronDownIcon boxSize={5} className='!text-[#8F9BBA]'/>
                    )}
                  </Box>
                )}
              </Flex>
            </HStack>
          </NavLink>

          {route.children && (
            <Collapse in={openDropdowns[routePath]}>
              <Box pl="30px">{renderLinks(route.children)}</Box>
            </Collapse>
          )}
        </Box>
      );
    });
  };

  return <>{renderLinks(routes)}</>;
}

export default SidebarLinks;
